// src/dokumentklassen/index.js
// Registry aller Dokumentklassen-Tabs. App.js (TabPanel-Rendering) und Header.jsx
// (Tab-Navigation) leiten ihre Tab-Liste hieraus ab, statt sie einzeln hart zu codieren.
// Eine neue Dokumentklasse hinzuzufügen heißt dann: eigenen Tab bauen + hier eine Zeile
// ergänzen - App.js/Header.jsx bleiben unangetastet.
import RechnungTab from './rechnung/RechnungTab';
// import BatchExtraction from './rechnung/BatchExtraction'; // vorerst ausgeblendet
// später: import LieferscheinTab from './lieferschein/LieferscheinTab';

export const DOKUMENTKLASSEN = [
  { pfad: '/extraction', titel: 'Rechnung', component: RechnungTab },
  // { pfad: '/batch', titel: 'Batchextraktion', component: BatchExtraction },
  // { pfad: '/lieferschein', titel: 'Lieferschein', component: LieferscheinTab },
];

export default DOKUMENTKLASSEN;